import { render, staticRenderFns } from "./api-type.vue?vue&type=template&id=d594e9d6&"
import script from "./api-type.vue?vue&type=script&lang=js&"
export * from "./api-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports